<template>
  <div v-if="skeleton" class="skeleton">
    <p v-if="text" class="price__text text-label skeleton">&nbsp;</p>
    <p class="price__price skeleton">
      <strong>&nbsp;</strong>
    </p>
  </div>
  <div v-else class="price" :class="{ 'price--compare': compare }">
    <p class="price__price text-secondary mb-0">
      <del v-if="compare" class="compare-at-price"
        ><span
          >{{ formattedPrice }}&nbsp;<span v-html="showCurrency"></span></span
      ></del>
      <strong v-else
        >{{ formattedPrice }}&nbsp;<span v-html="showCurrency"></span
      ></strong>
    </p>
    <p
      v-if="text"
      class="price__text text-label text-uppercase"
      :class="compare ? 'w-400' : 'w-600'"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
import { CURRENCY } from '@/const'

export default {
  name: 'Price',
  props: {
    /**
     * Texte au dessus du prix
     */
    text: { type: String, default: null },
    /**
     * Le produit dont le composant doit afficher le prix
     */
    price: { type: Number, required: true },
    /** Quel est la monnaie à afficher */
    currency: {
      type: String,
      default: CURRENCY.EUR,
    },
    /**
     * Est-ce que le prix est barré
     */
    compare: { type: Boolean, default: false },
    /**
     * Le composant est affiché en squelette de chargement
     */
    skeleton: { type: Boolean, default: false },
    /**
     * montre les centimes
     */
    showCents: { type: Boolean, default: false },
  },
  computed: {
    showCurrency() {
      switch (this.currency) {
        case CURRENCY.EUR:
          return '&euro;'
      }

      return ''
    },
    formattedPrice() {
      return this.showCents
        ? this.price.toLocaleString(this.$i18n.locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        : this.price.toLocaleString(this.$i18n.locale, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })
    },
  },
}
</script>

<style lang="scss">
.price {
  &__text {
    white-space: nowrap;
  }

  &__price {
    font-size: var(--h4-font-size);
    line-height: 1.25;
  }

  p {
    margin-bottom: 0;
  }

  &--compare {
    color: var(--secondary-color-3);

    del {
      text-decoration: none;
    }
  }
}
</style>
